import {
  Center,
  Container,
  Group,
  Loader,
  SimpleGrid,
  Tabs,
  Text,
  createStyles,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getPackages } from "../../../../services/package";

import PlanCard from "../../../../components/PlanCard";
import { dateFormat2 } from "../../../../utils";
import { getAllStaff } from "../../../../services/staff";
const useStyles = createStyles((theme) => ({
  "& .mantine-usvkjp": {
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
  },
  wrapperContainer: {
    height: "60vh",
    paddingLeft: "0 !important",
    paddingRight: "0 !important",
    "@media (max-width :80em)": {
      margin: "1rem 0!important",
    },
  },
  inputContainer: {
    "@media (max-width :80em)": {
      display: "flex !important",
      flexDirection: "column !important",
      paddingBottom: "4rem !important",
    },
  },
  comingSoonText: {
    fontFamily: "Inter",
    fontSize: "30px",
    fontWeight: "400",
    lineHeight: "50px",
    textAlign: "left",
    marginBottom: "30px",
    "@media (max-width: 768px)": {
      fontSize: "30px",
      lineHeight: "30px",
    },
  },
  monthlyAndYearlyTab: {
    "& .mantine-Tabs-tabsList": {
      marginBottom: "40px",
      width: "fit-content",
      backgroundColor: "#171717",
      marginInline: "auto",
      borderRadius: "28px",
      padding: "4px",
      "& .mantine-Tabs-tab": {
        color: "#FFFFFF",
        fontFamily: "Inter",
        fontSize: "20px",
        fontWeight: "400",
        padding: "14px 30px",
        borderRadius: "28px",
        "&:hover": {
          backgroundColor: "#171717",
          color: "#FFFFFF",
          opacity: 0.9,
        },
        "&[data-active]": {
          backgroundColor: "#FFAF4A",
          "&:hover": {
            backgroundColor: "#FFAF4A",
            color: "#FFFFFF",
            opacity: "unset",
          },
        },
      },
    },
  },
}));
const Upgrade = () => {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const [packages, setPackages] = useState([]);
  const [activeTab, setActiveTab] = useState(
    profile?.subscription?.subscriptionType || "month"
  );
  const [loadingPackages, setLoadingPackages] = useState(false);

  const packageFn = async () => {
    setLoadingPackages(true);
    const resp = await getPackages(profile?.user?.id);
    if (resp) {
      let tempPackages = resp?.packages;

      const sortedByCost = tempPackages.sort((a, b) => {
        return Number(a.cost) - Number(b.cost);
      });

      setLoadingPackages(false);
      setPackages(sortedByCost);
    } else {
      loadingPackages(false);
    }
  };

  useEffect(() => {
    packageFn();
    getAllStaff("activeStaff");
  }, []);

  return (
    <Container
      fluid
      sx={{ width: "100%" }}
      mt={50}
      className={classes.wrapperContainer}
    >
      <Tabs
        variant="pills"
        className={classes.monthlyAndYearlyTab}
        value={activeTab}
        onTabChange={(value) => setActiveTab(value)}
      >
        <Tabs.List>
          <Tabs.Tab value="month">Monthly</Tabs.Tab>
          <Tabs.Tab value="year">Yearly</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={activeTab}>
          {/* {activeTab === "year" && (
            <Center>
              <Text className={classes.comingSoonText}>
                Yearly Package Coming Soon
              </Text>
            </Center>
          )} */}
          <SimpleGrid cols={3} spacing={30} className={classes.inputContainer}>
            {loadingPackages ? (
              <Group cols={2}>
                <Loader color="yellow" size={"md"} />
                <Text>Loading, Please Wait...</Text>
              </Group>
            ) : (
              packages
                ?.filter(
                  ({ type, duration }) =>
                    type !== "skypoint" && duration === activeTab
                )
                ?.map((item) => {
                  const isFreePackage = item?.name === "Free";
                  if (
                    isFreePackage &&
                    profile?.subscription?.packageId?.name !== "Free"
                  ) {
                    return null;
                  }

                  return (
                    <PlanCard
                      allPackages={packages}
                      activeId={profile?.subscription?.packageId}
                      packageId={item?.id}
                      plan={item}
                      title={item?.name}
                      price={item?.cost}
                      duration={item?.duration}
                      level={item?.level}
                      stripePlanId={item?.stripeId}
                      desc={
                        isFreePackage
                          ? `${item?.staff} Staff Members, ${item?.facility} Facility, ${item?.patient} Patients & ${item?.dailyUpdates} Daily Updates`
                          : undefined
                      }
                      btn={
                        Number(item?.level) >
                        Number(profile?.subscription?.packageId?.level)
                          ? "Upgrade Plan"
                          : "Select Plan"
                      }
                      billing={
                        activeTab === "year"
                          ? `${dateFormat2(
                              profile?.subscription?.startedAt,
                              true
                            )} - ${dateFormat2(
                              profile?.subscription?.expiredAt,
                              true
                            )}`
                          : `${dateFormat2(
                              profile?.subscription?.startedAt,
                              false
                            )} - ${dateFormat2(
                              profile?.subscription?.expiredAt,
                              false
                            )}`
                      }
                      //                       billing={`${dateFormat2(
                      //                         profile?.subscription?.startedAt
                      //                       )} -
                      // ${dateFormat2(profile?.subscription?.expiredAt)}`}
                    />
                  );
                })
            )}
          </SimpleGrid>
        </Tabs.Panel>
      </Tabs>
    </Container>
  );

  //   return (
  //     <Container
  //       fluid
  //       sx={{ width: "100%" }}
  //       mt={50}
  //       className={classes.wrapperContainer}
  //     >
  //       <SimpleGrid cols={3} spacing={30} className={classes.inputContainer}>
  //         {loadingPackages ? (
  //           <Group cols={2}>
  //             <Loader color="yellow" size={"md"} />
  //             <Text>Loading, Please Wait...</Text>
  //           </Group>
  //         ) : (
  //           packages?.map((item) => {
  //             return Number(item?.cost) === 0 ? (
  //               // profile?.isEligibleForTrial ? (
  //               <PlanCard
  //                 activeId={profile?.subscription?.packageId}
  //                 packageId={item?.id}
  //                 title={item?.name}
  //                 plan={item}
  //                 price={item?.cost}
  //                 level={item?.level}
  //                 duration={item?.duration}
  //                 stripePlanId={item?.stripeId}
  //                 desc={`${item?.staff} Staff Members, ${item?.facility} Facility, ${item?.patient} Patients & ${item?.dailyUpdates} Daily Updates`}
  //                 btn={
  //                   Number(item?.level) >
  //                   Number(profile?.subscription?.packageId?.level)
  //                     ? "Upgrade Plan"
  //                     : "Select Plan"
  //                 }
  //                 billing={`${dateFormat2(profile?.subscription?.startedAt)} -
  //             ${dateFormat2(profile?.subscription?.expiredAt)}`}
  //               />
  //             ) : (
  //               // ) : null
  //               <PlanCard
  //                 // allPackages={packages?.packages}
  //                 allPackages={packages}
  //                 activeId={profile?.subscription?.packageId}
  //                 packageId={item?.id}
  //                 plan={item}
  //                 title={item?.name}
  //                 price={item?.cost}
  //                 duration={item?.duration}
  //                 level={item?.level}
  //                 stripePlanId={item?.stripeId}
  //                 btn={
  //                   Number(item?.level) >
  //                   Number(profile?.subscription?.packageId?.level)
  //                     ? "Upgrade Plan"
  //                     : "Select Plan"
  //                 }
  //                 billing={`${dateFormat2(profile?.subscription?.startedAt)} -
  // ${dateFormat2(profile?.subscription?.expiredAt)}`}
  //               />
  //             );
  //           })
  //         )}
  //       </SimpleGrid>
  //     </Container>
  //   );
};

export default Upgrade;
